export type LayoutType = "bare" | "fullheight" | "standard" | "fullheight-no-padding";
